<template>
  <div>
    <!-- <div class="text-editor-section rounded-5" :class="basic ? 'min-height-100' : 'min-height-300'"> -->
    <div
      class="text-editor-section rounded-5"
      :class="basic ? 'min-height-100' : null"
    >
      <ckeditor
        v-if="action === 'update'"
        :editor="editor"
        :config="editorConfig"
        v-model="editor_value"
      ></ckeditor>
      <ckeditor v-else :config="editorConfig" v-model="value"></ckeditor>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextEditor",

  props: {
    action: {
      type: String,
      default: "create",
    },
    content: String,
    basic: Boolean,
    event_name: String,
  },

  computed: {
    editor_value: {
      set: function(val) {
        this.$emit(this.event_name, val);
      },
      get: function() {
        return this.content;
      },
    },
  },

  watch: {
    content: {
      handler(update) {
        this.$emit(this.event_name, update);
        this.value = update;
      },
      immediate: true,
    },

    value: {
      handler(update) {
        this.$emit(this.event_name, update);
        this.value = update;
      },
      immediate: true,
    },
  },

  data() {
    return {
      value: this.content,
      editor: "",

      editorConfig: {
        height: "130px",
        autoGrow_minHeight: "40",

        fontSize_sizes: "14.5px",

        toolbarGroups: [
          {
            name: "basicstyles",
            groups: ["basicstyles"],
          },
          {
            name: "paragraph",
            groups: ["list"],
          },
          {
            name: "insert",
            groups: ["insert"],
          },
        ],
        // Remove the redundant buttons from toolbar groups defined above.
        removeButtons: "Strike,Anchor,Styles,Specialchar,Image,Table",
      },
    };
  },

  mounted() {
    // this.value = this.content;
  },
};
</script>

<style lang="scss" scoped></style>
